import { useNotification } from "@/shared/feedback/notification";
import { useMutation } from "@apollo/client";
import { useTranslations } from "use-intl";
import { SAVE_NOTIFICATION_TEMPLATE } from "../api/save-notification-template";
import { GET_NOTIFICATION_TEMPLATE } from "../api/get-notification-template";
import { FieldsType } from "./types";

export function useSaveNotificationTemplate({
  id,
  afterSubmit,
}: {
  id?: string;
  afterSubmit?: () => void;
}) {
  const t = useTranslations("TemplateForm");
  const notify = useNotification();

  const [saveNotificationTemplate, { loading }] = useMutation(
    SAVE_NOTIFICATION_TEMPLATE,
    {
      refetchQueries: [{ query: GET_NOTIFICATION_TEMPLATE, variables: { id } }],
    },
  );

  const save = async (template: FieldsType) => {
    const response = await saveNotificationTemplate({
      variables: { template },
    });

    if (response.data?.saveNotificationTemplateValue) {
      notify?.success({
        message: t("Notification template saved"),
      });

      afterSubmit?.();
    }
  };

  return {
    save,
    loading,
  };
}
